/**
 * Las paginas que el scroll infinito ya sumo, por entrada del historial.
 *
 * Al volver con el boton atras la vista se monta de nuevo y su estado arranca
 * vacio: sin esto quedaba solo la primera pagina, y `VolverArriba` no tenia
 * hasta donde bajar. Vive en memoria, como el historial de la SPA: recargar
 * la pagina lo pierde, y eso esta bien.
 */
import type { ProductoResumen } from '@elcarpintero/compartido';

export interface PaginasSumadas {
  /** El listado del que salieron (termino, filtros, pagina de entrada). */
  clave: string;
  /** Ultima pagina ya sumada. */
  pagina: number;
  productos: ProductoResumen[];
}

/** Mas que esto no se vuelve atras en la practica; tope para no crecer sin fin. */
const MAXIMO_ENTRADAS = 20;

const memoria = new Map<string, PaginasSumadas>();

export function recordarPaginas(entrada: string, paginas: PaginasSumadas): void {
  memoria.delete(entrada);
  memoria.set(entrada, paginas);
  if (memoria.size > MAXIMO_ENTRADAS) {
    const masVieja = memoria.keys().next().value;
    if (masVieja !== undefined) memoria.delete(masVieja);
  }
}

/** Lo recordado para esa entrada del historial, si es del mismo listado. */
export function paginasRecordadas(entrada: string, clave: string): PaginasSumadas | null {
  const guardadas = memoria.get(entrada);
  return guardadas !== undefined && guardadas.clave === clave ? guardadas : null;
}
